export default __webpack_public_path__ + "static/media/approvedIcon.cfe1a14e.jpg";